import { Injectable } from "@angular/core";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { Actions, Effect } from "@ngrx/effects";
import { Observable } from "rxjs/Observable";
import * as actions from "./config.actions";
import { Action } from "@ngrx/store";
import { AlertController, Platform } from "ionic-angular";

@Injectable()
export class ConfigSideEffects {

    @Effect({dispatch: false})
    updateRestHost$: Observable<Action> = this.actions$
        .ofType(actions.UPDATE_REST_HOST)
        .do((action: actions.UpdateRestHostAction) => {
           this.updateRestConfig(action.payload, undefined);
        });

    @Effect({dispatch: false})
    updateRestEndpoint$: Observable<Action> = this.actions$
        .ofType(actions.UPDATE_REST_ENDPOINT)
        .do((action: actions.UpdateRestHostAction) => {
           this.updateRestConfig(undefined, action.payload);
        });

    @Effect({dispatch: false})
    updateRestHostAndEndpoint$: Observable<Action> = this.actions$
        .ofType(actions.UPDATE_REST_HOST_AND_ENDPOINT)
        .do((action: actions.UpdateRestHostAndEndpointAction) => {
           this.updateRestConfig(action.payload.host, action.payload.endpoint);
        });

    constructor(
        protected actions$: Actions,
        protected appFacade: VasAppFacade,
        protected platformService: Platform,
        protected alertController: AlertController
    ) {

    }

    protected updateRestConfig(host?: string, endpoint?: string): void {

        host = host || this.appFacade.config.REST.HOST;
        endpoint = endpoint || this.appFacade.config.REST.ENDPOINT;

        const alert = this.alertController.create({
            title: "Are you sure you want to change these settings? ",
            message: "This action will reset the app's local data. Any data uploaded to the server will not be affected by this.",
            buttons: [
                {
                    text: "OK",
                    handler: () => {
                        this.appFacade.loading.showLoading();
                        this.appFacade.stateManager.reset();

                        setTimeout(() => {
                            this.appFacade.objects.config.store.setRestHost(host);
                            this.appFacade.objects.config.store.setRestEndpoint(endpoint);
                            this.appFacade.loading.hideLoading();

                            this.appFacade.alert.ok(
                                "Success",
                                `Please login again for your settings to take effect`
                            );

                        }, 1000);
                    }
                },
                {
                    text: "Cancel",
                    handler: () => {
                        // noop
                    }
                }
            ]
        });
        alert.present();

    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/config/config.side-effects.ts